import { ParsedDay } from 'src/types/date-time.types';

export const getPreviousDate = (currentDate: Date): Date => {
  const prevDate = new Date(currentDate);
  prevDate.setDate(currentDate.getDate() - 1);
  return prevDate;
};

export const getNextDate = (currentDate: Date): Date => {
  const prevDate = new Date(currentDate);
  prevDate.setDate(currentDate.getDate() + 1);
  return prevDate;
};

export const getCurrentDay = (currentDate: Date): ParsedDay => {
  const date = currentDate.getDate();
  const day = currentDate.toLocaleString('en-US', { weekday: 'short' });
  const month = currentDate.toLocaleString('en-US', { month: 'long' });
  const year = currentDate.getFullYear();

  return { date, day, month, year };
};

export const getCurrentWeek = (today: Date): ParsedDay[] => {
  const currentDayIndex = today.getDay();
  const startOfWeek = new Date(today);
  startOfWeek.setDate(today.getDate() - currentDayIndex);
  const weekArray = [];

  for (let i = 0; i < 7; i++) {
    const currentDate = new Date(startOfWeek);
    currentDate.setDate(startOfWeek.getDate() + i);
    weekArray.push(getCurrentDay(currentDate));
  }

  return weekArray;
};

export const getMonthNumber = (monthName: string, locale = 'en-US') => {
  const date = new Date(Date.UTC(2000, 0, 1));
  for (let month = 0; month < 12; month++) {
    date.setUTCMonth(month);
    const monthString = date.toLocaleString(locale, { month: 'long' });
    if (monthString.toLowerCase() === monthName.toLowerCase()) {
      return month;
    }
  }
  return -1;
};

export const getDateRange = (
  startDate: Date,
  endDate: Date,
  everyOtherDay = true
) => {
  const dates = [];
  while (startDate <= endDate) {
    dates.push(new Date(startDate));
    const idx = everyOtherDay ? 2 : 1;
    startDate.setDate(startDate.getDate() + idx);
  }
  if (dates[dates.length - 1] > endDate) {
    dates.pop();
  }

  return dates;
};

export const isDateInRange = (date: Date, startDate: Date, endDate: Date) => {
  const checkDate = new Date(date);
  return checkDate >= new Date(startDate) && checkDate <= new Date(endDate);
};

export const isSameMonth = (date1: Date, date2: Date) => {
  return (
    date1.getFullYear() === date2.getFullYear() &&
    date1.getMonth() === date2.getMonth()
  );
};

export const isDateInList = (dateToCheck: Date, dateList: Date[]) => {
  const checkDate = new Date(dateToCheck);
  checkDate.setHours(0, 0, 0, 0);

  return dateList.some((date) => {
    const listDate = new Date(date);
    listDate.setHours(0, 0, 0, 0);
    return checkDate.getTime() === listDate.getTime();
  });
};
